import { TripOrigin, Place } from '@mui/icons-material'

const Locations = ({ originName, destinationName }) => {
  return (
    <div className={`relative`}>
      <div className='flex-1'>
        <Location location={originName} filled={true} />
        <Conector />
        <Location location={destinationName} filled={false} />
      </div>
    </div>
  )
}

const Location = ({ location, filled }) => (
  <div className='flex items-center'>
    <div className='w-5 flex justify-center mx-1'>
      <div
        className={`w-3.5 h-3.5 rounded-full ${
          filled ? 'bg-light_coral' : 'bg-white dark:bg-dk-surface border-2 border-light_coral'
        }`}
      />
    </div>
    <span className='text-sm font-light md:text-base'>{location}</span>
  </div>
)

const Conector = () => (
  <div className='flex h-5'>
    <div className='w-px h-full bg-gray dark:bg-dk-border mx-[13.5px]' />
  </div>
)

export default Locations
